import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { VersioningService } from '../../../../core/services/versioning/versioning.service';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
	private readonly versioningService = inject(VersioningService);

	/**
	 * Get current application version only
	 */
	public get appVersion(): string {
		const current = this.versioningService.versionState().current;
		return current?.version || '';
	}

	/**
	 * Get current build hash only
	 */
	public get buildHash(): string {
		const current = this.versioningService.versionState().current;
		return current?.build || '';
	}
}
